<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer/>
      <div class="d-flex justify-end align-center mr-3">
        <v-text-field
          :value="searchOrder"
          append-icon="mdi-magnify"
          label="Busca ordenes por id"
          solo
          hide-details
          rounded
          flat
          dense
          @input="search"/>
      </div>
    </div>

    <v-flex xs12>
      <v-skeleton-loader v-show="overlay" type="table" />
      <v-data-table
        v-show="!overlay"
        :loading-text="table.title"
        :loading="table.loading"
        :headers="table.headers"
        :items="tableData"
        :server-items-length="tableTotal"
        :options="tableOptions"
        :items-per-page="50"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50]
        }"
        sort-by="name"
        @update:options="updateTable"
        class="elevation-1">
        <template v-slot:top>
          <div class="d-flex align-center pa-3">
            <div class="mr-3">
              Filtros:
            </div>
            <div class="mr-3">
              <v-menu
                ref="datePicker"
                v-model="datePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="range"
                    label="Rango de fechas"
                    prepend-icon="mdi-calendar"
                    readonly
                    hide-details
                    dense
                    v-on="on"
                  ></v-text-field>
                </template>
                  <!-- v-model="dates" -->
                <v-date-picker
                  v-model="dates"
                  :range="true"
                  first-day-of-week="1"
                  no-title
                >
                  <v-btn text color="primary" @click="resetDate">Borrar</v-btn>
                  <v-spacer/>
                  <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                  <v-btn :disabled="dates.length < 2" color="primary" @click="filter">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </div>
        </template>
        <template v-slot:item.provider="{ item }">
          {{ item.provider ? item.provider.name : '' }}
        </template>
        <template v-slot:item.createdAt="{ item }">
          {{ convertToDateString(item.createdAt) }}
        </template>
        <template v-slot:item.total="{ item }">
          <div class="text-end">
            {{ item.total | toFixNumber(2) | numberWithComma | prefix('$') }}
          </div>
        </template>
        <template v-slot:item.invoices="{ item }">
          <div class="d-flex">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="mr-3"
                  fab
                  color="primary"
                  x-small
                  depressed
                  @click="viewInvoice(item.invoices[0])">
                  <v-icon>
                    mdi-receipt
                  </v-icon>
                </v-btn>
              </template>
              <span>Ver Factura</span>
            </v-tooltip>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="mr-3"
                  fab
                  color="info"
                  x-small
                  depressed
                  @click="downloadInvoice(item._id, item.invoices[0])">
                  <v-icon>
                    mdi-xml
                  </v-icon>
                </v-btn>
              </template>
              <span>Descargar XML</span>
            </v-tooltip>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="mr-3"
                  fab
                  color="#26A69A"
                  x-small
                  depressed
                  :href="downloadPDF((item.invoices[0]))"
                  target="_blank"
                  >
                  <v-icon color="white">
                    mdi-file-pdf
                  </v-icon>
                </v-btn>
              </template>
              <span>Descargar PDF</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <InvoiceViewer
      ref="invoice"
      @close="closeInvoiceViewer"/>
  </v-layout>
</template>

<script>
import InvoiceViewer from '@/components/modals/InvoiceViewer'
import { debounce, isEqual } from 'lodash'

export default {
  name: 'CommissionOrders',
  components: {
    InvoiceViewer
  },
  data () {
    return {
      section: 'Comisiones',
      table: {
        title: this.$i18n.t('sales.loading'),
        loading: false,
        total: 0,
        headers: [
          { text: 'No. de Orden de compra', value: 'uuid', sortable: false },
          { text: 'Proveedor', value: 'provider', sortable: false },
          { text: 'Fecha de emisión', value: 'createdAt', sortable: false },
          { text: 'Monto', value: 'total', sortable: false },
          { text: 'Facturas', value: 'invoices', sortable: false }
        ],
        data: [],
        options: {
          page: 1,
          itemsPerPage: 50,
          sortBy: ['name'],
          sortDesc: [],
          groupBy: [],
          groupDesc: [],
          mustSort: false,
          multiSort: false
        }
      },
      invoiceViewerOpen: false,
      order: {},
      datePicker: false,
      dates: [
        this.$moment().startOf('month').format('YYYY-MM-DD'),
        this.$moment().endOf('month').format('YYYY-MM-DD')
      ],
      uuid: ''
    }
  },
  computed: {
    range () {
      const dates = this.dates
      return dates.length < 2 ? '' : `${dates[0]} / ${dates[1]}`
    },
    tableOptions () {
      return this.table.options
    },
    tableTotal () {
      return this.table.total
    },
    tableData () {
      return this.table.data
    },
    overlay () {
      return this.table.loading
    },
    searchOrder () {
      return this.uuid
    },
    provider () {
      return process.env.VUE_APP_EATO_PROVIDER
    }
  },
  async mounted () {
    await this.load()
  },
  methods: {
    downloadPDF (item) {
      let url = process.env.VUE_APP_API_URL
      url += `/v1/invoices/${item._id}/factuapi-pdf`
      return url
    },
    filter: async function () {
      this.dates.sort((a, b) => {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      await this.load()
      this.datePicker = false
    },
    async resetDate () {
      this.dates = []
      await this.load()
      this.datePicker = false
    },
    search: debounce(async function (val) {
      this.uuid = val
      await this.load()
    }, 300),
    updateTable: async function (data) {
      if (!isEqual(this.table.options, data)) {
        this.table.options = data
        await this.load()
      }
    },
    async load () {
      this.table.loading = true
      try {
        const params = {
          limit: this.table.options.itemsPerPage,
          skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
          sort: '-createdAt',
          restaurant: this.$store.state.currentRestaurant.data._id,
          provider: this.provider,
          getInvoice: true
        }

        if (this.searchOrder.length >= 2) {
          params.uuid = `/${this.searchOrder}/gi`
        }

        if (this.dates.length) {
          const dates = this.dates.sort((a, b) => {
            if (a < b) return -1
            if (a > b) return 1
            return 0
          })
          params['createdAt>'] = dates[0]
          params['createdAt<'] = dates[1]
        }

        const response = await this.$api.get('/v1/orders', params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    convertToDateString (date) {
      const d = new Date(date)
      return d.toLocaleDateString()
    },
    viewInvoice: async function (invoice) {
      this.$refs.invoice.open(invoice)
    },
    closeInvoiceViewer () {
      this.invoiceViewerOpen = false
    },
    downloadInvoice: async function (order, invoice) {
      const response = await this.$api.get(`/v1/orders/${order}/invoices/${invoice._id}`)
      var element = document.createElement('a')
      element.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(response.content))
      element.setAttribute('download', `invoice-${invoice.uuid}`)

      element.style.display = 'none'
      document.body.appendChild(element)

      element.click()

      document.body.removeChild(element)
    }
  }
}
</script>
